export const BRAND_LOGOS = {
    "mastercard": "assets/cards/mastercard.png",
    "visa": "assets/cards/visa.png",
    "amex": "assets/cards/amex.png"
  }
  